import React, { useContext as useContextCore, useMemo } from 'react'
import type { ListFieldConfig, UseListWithSelection } from '@ztechapps/common.hook'
import { type UseListResult, useListWithSelection } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'
import { components as defaultComponents } from './components'
import merge from 'lodash/merge'
import { useProductList, useProductListFieldConfig } from '@ztechapps/product.common'

export type ProductSelectListProviderProps = {
  children: React.ReactNode
  components: any
}

export type ProductSelectListContextType = {
  productList: UseListResult<Product>
  listWithSelection: UseListWithSelection<Product>
  listFieldConfig: ListFieldConfig
} & Omit<ProductSelectListProviderProps, 'children'>

const context = React.createContext<ProductSelectListContextType>({} as ProductSelectListContextType)
const CoreProvider = context.Provider

export const ProductSelectListProvider = ({ children, components, ...props }: ProductSelectListProviderProps) => {
  components = merge({}, defaultComponents, components)
  const storageKey = 'product-select-list'

  const listFieldConfig = useProductListFieldConfig()

  const updatedListConfig = useMemo<ListFieldConfig>(() => {
    //we need to select which field to be default show
    const updated = { ...listFieldConfig }
    updated.name.isVisible = false
    updated.quantityOnHand.isVisible = false
    updated.computedQuantity.isVisible = false
    updated.category.isVisible = true
    updated.dieSetType.isVisible = true
    updated.remarks.isVisible = false
    updated.tags.isVisible = false
    return updated
  }, [listFieldConfig])

  const productList = useProductList({
    listActionOptions: {
      storageKey,
    },
  })

  const listWithSelection = useListWithSelection(productList.list)

  return (
    <CoreProvider
      value={{
        ...props,
        components,
        productList,
        listWithSelection,
        listFieldConfig: updatedListConfig,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useProductSelectListContext = () => useContextCore(context)
